<template>
    <div class="col-sm-12 p-lr-0-sm" v-if="permissionsGroupsList[`${viewingPermissionGroup}`]">
        <div class="row multisteps-form permissions-overview">
            <div class="col-sm-12 mb-4 p-lr-0-sm">
                <div class="card p-3 dis-flex flex-column">
                    <div class="dis-flex flex-m flex-sb mb-4 pos-relative">
                        <div class="dis-flex flex-m col-sm-8 col-md-8 col-lg-8 col-xl-8 col-xxl-8 p-0"
                            :class="{
                                'col-7': editingPermissionGroup,
                                'col-9': !editingPermissionGroup
                            }">
                            <div class="sidebar-cat-icon dis-flex flex-m flex-c">
                                <div class="uim-svg fs-15">
                                    <svg viewBox="0 0 24 24" width="1em">
                                        <path class="uim-tertiary" d="M12.979,15.50488a4.43353,4.43353,0,0,1-2.92627-1.09961,1.84838,1.84838,0,0,1-.23584-.2041.99994.99994,0,0,1,1.40137-1.42676.55055.55055,0,0,1,.11914.09668,2.45734,2.45734,0,0,0,3.38916-.09277l4.54785-4.54785a2.47832,2.47832,0,0,0-3.50488-3.50488L14.041,6.4541A.99989.99989,0,0,1,12.627,5.04l1.72852-1.72852a4.47811,4.47811,0,0,1,6.333,6.333l-4.54786,4.54785A4.4623,4.4623,0,0,1,12.979,15.50488Z"></path>
                                        <path class="uim-primary" d="M6.478,21.99805a4.47608,4.47608,0,0,1-3.16651-7.64258L7.85938,9.80762a4.4558,4.4558,0,0,1,6.08789-.21289,1.84838,1.84838,0,0,1,.23584.2041.99994.99994,0,0,1-1.40137,1.42676.55055.55055,0,0,1-.11914-.09668,2.45636,2.45636,0,0,0-3.38916.09277L4.72559,15.76953a2.47832,2.47832,0,0,0,3.50488,3.50488L9.959,17.5459A.99989.99989,0,0,1,11.373,18.96L9.64453,20.68848A4.4638,4.4638,0,0,1,6.478,21.99805Z"></path>
                                    </svg>
                                </div>
                            </div>
                            <label class="m-0" v-if="!editingPermissionGroup">{{ permissionsGroupsList[`${viewingPermissionGroup}`].group_name }}</label>
                            <input class="m-0 w-full" type="text" v-else v-model="permissionsGroupsList[`${viewingPermissionGroup}`].group_name">
                        </div>
                        <div class="buttons-whatch-attirute pos-absolute right-0 dis-flex">
                            <template v-if="!editingPermissionGroup">
                                <div class="btn small-form-btn bar-code fs-10 mt-0 pointer mr-3" title="Edit Permissions" v-if="!savingChanges" @click="enableEditMode(permissionsGroupsList[`${viewingPermissionGroup}`])">
                                    <i class="uis uis-edit-alt fs-11"></i>
                                </div>
                                <div class="btn small-form-btn bar-code fs-10 mt-0 pointer" title="Close Overview" @click="$emit('updatePermissionViewingGroup', false)">
                                    <i class="uis uis-multiply fs-11"></i>
                                </div>
                            </template>
                            <template v-else>
                                <div class="buttons-whatch-attirute delete-small-btn mr-3">
                                    <div class="btn small-form-btn bar-code fs-10 mt-0 pointer" title="Cancel Editing" @click="cancelEditMode(permissionsGroupsList[`${viewingPermissionGroup}`])">
                                        <small class="text-white text-uppercase fs-10 font-p">Cancel</small>
                                    </div>
                                </div>
                                <div class="buttons-whatch-attirute save-changes-small">
                                    <div class="btn small-form-btn bar-code fs-10 mt-0 pointer" title="Save Changes" @click="saveEditMode(permissionsGroupsList[`${viewingPermissionGroup}`])">
                                        <small class="text-white text-uppercase fs-10 font-p">save</small>
                                    </div>
                                </div>
                            </template>
                        </div>
                    </div>
                    <div class="col-12 col-sm-8 col-md-8 col-lg-8 col-xl-8 col-xxl-8 p-0 mb-4">
                        <label>Short Description</label>
                        <textarea class="small-txt-area w-full bor-dash" placeholder="This permission group description" maxlength="100" type="text" cols="7" rows="3" v-model="permissionsGroupsList[`${viewingPermissionGroup}`].group_description" :disabled="!editingPermissionGroup"></textarea>
                        <span class="fs-9 text-rose txt-italic pos-absolute p-lr-0-sm" style="right: 0px;" v-if="editingPermissionGroup">Max Symbols 100</span>
                    </div>
                    <div class="col-sm-12 mt-4 p-0 mb-2">
                        <div v-if="!permissionsGroupsList[`${viewingPermissionGroup}`].permissions_loaded == null">
                            Loading Permissions...
                        </div>
                        <div v-else-if="(!permissionsGroupsList[`${viewingPermissionGroup}`].group_permissions || Object.keys(permissionsGroupsList[`${viewingPermissionGroup}`].group_permissions).length == 0) && !editingPermissions">
                            <div class="fast-actions-block pl-5 pr-5 pb-5 pt-4 dis-flex flex-c flex-column w-full">
                                <div class="row">
                                    <div class="col-sm-12 p-lr-0-sm dis-flex flex-column flex-m flex-c">
                                        <p class="cl-txt-dark font-p mt-3 mb-4 text-center">You have not granted any permissions yet</p>
                                        <button class="btn button-create-atrb-btn mt-2 mb-2" type="button" title="Create Category" @click="enablePermissionsEditMode(permissionsGroupsList[`${viewingPermissionGroup}`])">Give Permisisions</button>
                                        <small class="m-b--35">Click the button to give permissions</small>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row" v-else-if="!editingPermissions">
                            <div class="col-sm-12 dis-flex flex-m flex-r p-lr-0-sm mb-2">
                                <div class="btn small-form-btn bar-code edit-mode fs-11im mt-0 pointer text-uppercase text-sm-d" title="Edit permissions" @click="enablePermissionsEditMode(permissionsGroupsList[`${viewingPermissionGroup}`])"><i class="uis uis-edit-alt fs-11 mr-2"></i>Edit</div>
                            </div>
                            <div class="col-sm-6 p-lr-0-sm pr-0 m-t-3">
                                <div class="dis-flex flex-column">
                                    <div class="dis-flex flex-m">
                                        <div class="dis-flex flex-m">
                                            <i class="uis uis-lock-open-alt mr-1 mb-2 text-blue"></i>
                                            <label>Granted Permissions</label>
                                        </div>
                                    </div>
                                    <div class="multisteps-form__form dis-flex flex-column noselect">
                                        <template v-for="(thisPermissionCategory, thisPermissionCategoryId) in thisPermGroupPermissionsByGroup" :key="thisPermissionCategoryId">
                                            <template v-if="checkForInnerPermissionsSelected(thisPermissionCategory)">
                                                <small class="access-title text-blue txt-italic fs-11 ml-3">Whole group access</small>
                                                <div class="fast-actions-block card pl-3 pr-3 pt-2 pb-2 dis-flex flex-column mb-62 multisteps-form__content pointer"
                                                    @click="thisPermissionCategory.grantedOpened = !thisPermissionCategory.grantedOpened">
                                                    <div class="col-sm-12 p-0 flex-m">
                                                        <h5 class="col-7 col-sm-8 col-md-9 col-lg-9 col-xl-9 col-xxl-10 p-0 text-sm-b">{{ thisPermissionCategory.name }}</h5>
                                                    </div>
                                                </div>
                                                <div class="row separate-group-access" v-show-slide="thisPermissionCategory.grantedOpened">
                                                    <div class="col-sm-12 p-lr-0-sm pr-0">
                                                        <div class="multisteps-form__form dis-flex flex-column ml-4">
                                                            <small class="text-blue txt-italic fs-11 ml-3">Separate accesses</small>
                                                            <template v-for="(thisPermCategoryPermission, thisPermCategoryPermissionName) in thisPermissionCategory.permissions" :key="thisPermCategoryPermissionName">
                                                                <div class="fast-actions-block card pl-3 pr-3 pt-2 pb-2 dis-flex flex-column multisteps-form__content pointer mb-62" v-if="thisPermCategoryPermission.selected">
                                                                    <i class="uis uis-info-circle info-tultip fs-15 pos-absolute pointer"></i>
                                                                    <div class="col-sm-12 p-0 flex-m">
                                                                        <h5 class="col-7 col-sm-8 col-md-9 col-lg-9 col-xl-9 col-xxl-10 p-0 text-sm-b">{{ thisPermCategoryPermission.description }}</h5>
                                                                    </div>
                                                                </div>
                                                            </template>
                                                        </div>
                                                    </div>
                                                </div>
                                            </template>
                                        </template>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row pl-3 pr-3 p-lr-0-sm-imp" v-else>
                            <div class="col-sm-12 dis-flex flex-m flex-r p-0 mb-2">
                                <div class="buttons-whatch-attirute dis-flex">
                                    <div class="buttons-whatch-attirute delete-small-btn mr-3" v-if="!savingPermissions">
                                        <div class="btn small-form-btn bar-code fs-10 mt-0 pointer" title="Cancel Editing" @click="cancelPermissionsEditMode(permissionsGroupsList[`${viewingPermissionGroup}`])">
                                            <small class="text-white text-uppercase fs-10 font-p">Cancel</small>
                                        </div>
                                    </div>
                                    <div class="buttons-whatch-attirute save-changes-small">
                                        <div class="btn small-form-btn bar-code fs-10 mt-0 pointer" v-if="!savingPermissions" title="Save Changes" @click="savePermissionsEditMode(permissionsGroupsList[`${viewingPermissionGroup}`])">
                                            <small class="text-white text-uppercase fs-10 font-p">save</small>
                                        </div>
                                        <div class="btn small-form-btn bar-code mt-0 pointer pos-relative" v-else title="Changes saving">
                                            <small class="text-white text-uppercase fs-10 font-p op-00">save</small>
                                            <span class="spinner-border text-white spinner-border-sm spin m-0 pos-absolute spin-save-pos"></span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="content-swipe-scroller snap-inline-element">
                                <div class="dis-flex flex-column">
                                    <div class="dis-flex flex-m">
                                        <div class="dis-flex flex-m">
                                            <i class="uis uis-padlock mr-1 mb-2 text-rose"></i>
                                            <label>Available Permissions</label>
                                        </div>
                                        <div class="dis-flex flex-m ml-auto mobile-swipe-info-help mb-2">
                                            <i class="uis uis-angle-double-left text-rose fs-16 mr-1 m-b--2"></i>
                                            <small class="text-rose font-p text-uppercase fs-9">swipe</small>
                                        </div>
                                    </div>
                                    <div class="multisteps-form__form dis-flex flex-column noselect">
                                        <template v-for="(thisPermissionCategory, thisPermissionCategoryId) in thisPermGroupPermissionsByGroup" :key="thisPermissionCategoryId">
                                            <template v-if="checkForInnerPermissionsSelected(thisPermissionCategory, true)">
                                                <small class="text-rose access-title txt-italic fs-11 ml-3">Whole group access</small>
                                                <div class="fast-actions-block w-full card pl-3 pr-3 pt-2 pb-2 dis-flex flex-column mb-62 multisteps-form__content pointer"
                                                    @click="thisPermissionCategory.availableOpened = !thisPermissionCategory.availableOpened">
                                                    <div class="col-sm-12 p-0 flex-m">
                                                        <h5 class="col-7 col-sm-8 col-md-9 col-lg-9 col-xl-9 col-xxl-10 p-0 text-sm-b">{{ thisPermissionCategory.name }}</h5>
                                                        <div class="buttons-whatch-attirute give-permission-small pos-absolute right-0 dis-flex flex-m">
                                                            <div class="btn small-form-btn bar-code mt-0 pointer" title="Give Permissions Group" @click.stop="changePermissionsSelectedInPermGroup(thisPermissionCategory, true)" v-if="!savingPermissions">
                                                                <small class="text-white text-uppercase fs-8 font-p">Enable Group</small>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="row separate-group-access" v-show-slide="thisPermissionCategory.availableOpened">
                                                    <div class="col-sm-12 p-lr-0-sm pr-0">
                                                        <div class="multisteps-form__form dis-flex flex-column ml-4">
                                                            <small class="text-rose txt-italic fs-11 ml-3">Separate accesses</small>
                                                            <template v-for="(thisPermCategoryPermission, thisPermCategoryPermissionName) in thisPermissionCategory.permissions" :key="thisPermCategoryPermissionName">
                                                                <div class="fast-actions-block w-full card pl-3 pr-3 pt-2 pb-2 dis-flex flex-column multisteps-form__content pointer mb-62" v-if="!thisPermCategoryPermission.selected">
                                                                    <template v-if="thisPermCategoryPermission.big_description_opened">
                                                                        <span class="uim-svg ml-auto info-tultip fs-15 pos-absolute pointer" title="Close Description"  @click="thisPermCategoryPermission.big_description_opened = false">
                                                                            <svg viewBox="0 0 24 24" width="1em">
                                                                                <path class="uim-primary-w" d="M13.41406,12l2.293-2.293A.99989.99989,0,0,0,14.293,8.293L12,10.58594,9.707,8.293A.99989.99989,0,0,0,8.293,9.707L10.58594,12,8.293,14.293A.99989.99989,0,1,0,9.707,15.707L12,13.41406l2.293,2.293A.99989.99989,0,0,0,15.707,14.293Z"></path>
                                                                                <path class="uim-tertiary-g" d="M19,2H5A3.00328,3.00328,0,0,0,2,5V19a3.00328,3.00328,0,0,0,3,3H19a3.00328,3.00328,0,0,0,3-3V5A3.00328,3.00328,0,0,0,19,2ZM15.707,14.293A.99989.99989,0,1,1,14.293,15.707L12,13.41406,9.707,15.707A.99989.99989,0,0,1,8.293,14.293L10.58594,12,8.293,9.707A.99989.99989,0,0,1,9.707,8.293L12,10.58594l2.293-2.293A.99989.99989,0,0,1,15.707,9.707L13.41406,12Z"></path>
                                                                            </svg> 
                                                                        </span>
                                                                        <div class="col-sm-12 p-0 flex-m">
                                                                            <small class="col-sm-12 p-0 fs-13 fw-regular text-blue">{{ thisPermCategoryPermission.big_description }}</small>
                                                                        </div>
                                                                    </template>
                                                                    <template v-else>
                                                                        <i class="uis uis-info-circle info-tultip fs-15 pos-absolute pointer" title="Open Description" v-if="thisPermCategoryPermission.big_description && thisPermCategoryPermission.big_description.length > 0" @click="thisPermCategoryPermission.big_description_opened = true"></i>
                                                                        <div class="col-sm-12 p-0 flex-m">
                                                                            <h5 class="col-7 col-sm-8 col-md-9 col-lg-9 col-xl-9 col-xxl-10 p-0 text-sm-b">{{ thisPermCategoryPermission.description }}</h5>
                                                                            <div class="buttons-whatch-attirute give-permission-small pos-absolute right-0">
                                                                                <div class="btn small-form-btn bar-code mt-0 pointer" title="Give Permission" @click="thisPermCategoryPermission.selected = true" v-if="!savingPermissions">
                                                                                    <small class="text-white text-uppercase fs-8 font-p">Enable</small>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </template>
                                                                </div>
                                                            </template>
                                                        </div>
                                                    </div>
                                                </div>
                                            </template>
                                        </template>
                                    </div>
                                </div>
                                <div class="dis-flex flex-column">
                                    <div class="dis-flex flex-m">
                                        <div class="dis-flex flex-m">
                                            <i class="uis uis-lock-open-alt mr-1 mb-2 text-blue"></i>
                                            <label>Granted Permissions</label>
                                        </div>
                                        <div class="dis-flex flex-m ml-auto mobile-swipe-info-help mb-2">
                                            <small class="text-blue font-p text-uppercase fs-9">swipe</small>
                                            <i class="uis uis-angle-double-right text-blue fs-16 ml-1 m-b--2"></i>
                                        </div>
                                    </div>
                                    <div class="multisteps-form__form dis-flex flex-column noselect">
                                        <template v-for="(thisPermissionCategory, thisPermissionCategoryId) in thisPermGroupPermissionsByGroup" :key="thisPermissionCategoryId">
                                            <template v-if="checkForInnerPermissionsSelected(thisPermissionCategory)">
                                                <small class="access-title text-blue txt-italic fs-11 ml-3">Whole group access</small>
                                                <div class="fast-actions-block card pl-3 pr-3 pt-2 pb-2 dis-flex flex-column mb-62 multisteps-form__content pointer"
                                                    @click="thisPermissionCategory.grantedOpened = !thisPermissionCategory.grantedOpened">
                                                    <div class="col-sm-12 p-0 flex-m">
                                                        <h5 class="col-7 col-sm-8 col-md-9 col-lg-9 col-xl-9 col-xxl-10 p-0 text-sm-b">{{ thisPermissionCategory.name }}</h5>
                                                        <div class="buttons-whatch-attirute disable-permission-small pos-absolute right-0 dis-flex flex-m">
                                                            <div class="btn small-form-btn bar-code mt-0 pointer" title="Cancel Permissions Group" @click.stop="changePermissionsSelectedInPermGroup(thisPermissionCategory, false)" v-if="!savingPermissions">
                                                                <small class="text-white text-uppercase fs-8 font-p">Disable Group</small>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="row separate-group-access" v-show-slide="thisPermissionCategory.grantedOpened">
                                                    <div class="col-sm-12 p-lr-0-sm pr-0">
                                                        <div class="multisteps-form__form dis-flex flex-column ml-4">
                                                            <small class="text-blue txt-italic fs-11 ml-3">Separate accesses</small>
                                                            <template v-for="(thisPermCategoryPermission, thisPermCategoryPermissionName) in thisPermissionCategory.permissions" :key="thisPermCategoryPermissionName">
                                                                <div class="fast-actions-block card pl-3 pr-3 pt-2 pb-2 dis-flex flex-column multisteps-form__content pointer mb-62" v-if="thisPermCategoryPermission.selected">
                                                                    <template v-if="thisPermCategoryPermission.big_description_opened">
                                                                        <span class="uim-svg ml-auto info-tultip fs-15 pos-absolute pointer" title="Close Description"  @click="thisPermCategoryPermission.big_description_opened = false">
                                                                            <svg viewBox="0 0 24 24" width="1em">
                                                                                <path class="uim-primary-w" d="M13.41406,12l2.293-2.293A.99989.99989,0,0,0,14.293,8.293L12,10.58594,9.707,8.293A.99989.99989,0,0,0,8.293,9.707L10.58594,12,8.293,14.293A.99989.99989,0,1,0,9.707,15.707L12,13.41406l2.293,2.293A.99989.99989,0,0,0,15.707,14.293Z"></path>
                                                                                <path class="uim-tertiary-g" d="M19,2H5A3.00328,3.00328,0,0,0,2,5V19a3.00328,3.00328,0,0,0,3,3H19a3.00328,3.00328,0,0,0,3-3V5A3.00328,3.00328,0,0,0,19,2ZM15.707,14.293A.99989.99989,0,1,1,14.293,15.707L12,13.41406,9.707,15.707A.99989.99989,0,0,1,8.293,14.293L10.58594,12,8.293,9.707A.99989.99989,0,0,1,9.707,8.293L12,10.58594l2.293-2.293A.99989.99989,0,0,1,15.707,9.707L13.41406,12Z"></path>
                                                                            </svg> 
                                                                        </span>
                                                                        <div class="col-sm-12 p-0 flex-m">
                                                                            <small class="col-sm-12 p-0 fs-13 fw-regular text-blue">{{ thisPermCategoryPermission.big_description }}</small>
                                                                        </div>
                                                                    </template>
                                                                    <template v-else>
                                                                        <i class="uis uis-info-circle info-tultip fs-15 pos-absolute pointer" title="Open Description" v-if="thisPermCategoryPermission.big_description && thisPermCategoryPermission.big_description.length > 0" @click="thisPermCategoryPermission.big_description_opened = true"></i>
                                                                        <div class="col-sm-12 p-0 flex-m">
                                                                            <h5 class="col-7 col-sm-8 col-md-9 col-lg-9 col-xl-9 col-xxl-10 p-0 text-sm-b">{{ thisPermCategoryPermission.description }}</h5>
                                                                            <div class="buttons-whatch-attirute disable-permission-small pos-absolute right-0">
                                                                                <div class="btn small-form-btn bar-code mt-0 pointer" title="Cancel Permission" @click="thisPermCategoryPermission.selected = false" v-if="!savingPermissions">
                                                                                    <small class="text-white text-uppercase fs-8 font-p">Disable</small>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </template>
                                                                </div>
                                                            </template>
                                                        </div>
                                                    </div>
                                                </div>
                                            </template>
                                        </template>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Swal from 'sweetalert2';

export default {
    props: {
        viewingPermissionGroup: {
            required: true,
        },
        permissionsGroupsList: {
            type: Object,
            required: true
        },
        allPermissionsByGroup: {
            type: Object,
            required: true
        }
    },
    emits: [
        'updatePermissionViewingGroup',
        'getPermissionsGroups'
    ],
    data() {
        return {
            editingPermissionGroup: false,
            editingPermissions: false,
            savingChanges: false,
            thisPermGroupPermissionsByGroup: {},
            savingPermissions: false,
        }
    },
    mounted() {
        if (!this.permissionsGroupsList[`${this.viewingPermissionGroup}`]) {
            this.$emit('updatePermissionViewingGroup', false)
        }

        this.thisPermGroupPermissionsByGroup = JSON.parse(JSON.stringify(this.allPermissionsByGroup))
        for (const key in this.thisPermGroupPermissionsByGroup) {
            if (this.thisPermGroupPermissionsByGroup.hasOwnProperty(key)) {
                this.thisPermGroupPermissionsByGroup[key].availableOpened = false
                this.thisPermGroupPermissionsByGroup[key].grantedOpened = false
            }
        }
        this.compareThisPermGroupPermissions()
    },
    watch: {
        'permissionsGroupsList[`${this.viewingPermissionGroup}`].permissions_loaded': function(newVal, oldVal) {
            if (newVal) {
                this.compareThisPermGroupPermissions()
            }
        },
    },
    methods: {
        compareThisPermGroupPermissions() {
            if (this.permissionsGroupsList[`${this.viewingPermissionGroup}`].permissions_loaded) {
                for (const key in this.permissionsGroupsList[`${this.viewingPermissionGroup}`].group_permissions) {
                    if (!this.permissionsGroupsList[`${this.viewingPermissionGroup}`].group_permissions.hasOwnProperty(key)) {
                        continue
                    }

                    const thisSelectedPermGroupPermission = this.permissionsGroupsList[`${this.viewingPermissionGroup}`].group_permissions[key];
                    if (!thisSelectedPermGroupPermission.group_id) continue
                    else if (!this.thisPermGroupPermissionsByGroup.hasOwnProperty(`${thisSelectedPermGroupPermission.group_id}`)) {
                        continue
                    } else if (!this.thisPermGroupPermissionsByGroup[`${thisSelectedPermGroupPermission.group_id}`].hasOwnProperty(`${key}`)) {
                        continue
                    }

                    this.thisPermGroupPermissionsByGroup[`${thisSelectedPermGroupPermission.group_id}`][`${key}`].selected = true;
                }
            }
        },
        checkForInnerPermissionsSelected(thisPermissionsCategoryGroup, ifNotSelected = false) {
            if (!ifNotSelected) {
                let anyInnerPermissionSelected = false;
                for (const key in thisPermissionsCategoryGroup.permissions) {
                    if (!thisPermissionsCategoryGroup.permissions.hasOwnProperty(key)) {
                        continue
                    }

                    let thisPermCategoryPermission = thisPermissionsCategoryGroup.permissions[key];
                    if (thisPermCategoryPermission.selected) {
                        anyInnerPermissionSelected = true;
                        break;
                    }
                }

                return anyInnerPermissionSelected
            } else {
                let anyInnerPermissionNotSelected = false;
                for (const key in thisPermissionsCategoryGroup.permissions) {
                    if (!thisPermissionsCategoryGroup.permissions.hasOwnProperty(key)) {
                        continue
                    }

                    let thisPermCategoryPermission = thisPermissionsCategoryGroup.permissions[key];
                    if (!thisPermCategoryPermission.selected) {
                        anyInnerPermissionNotSelected = true;
                        break;
                    }
                }

                return anyInnerPermissionNotSelected
            }
        },
        changePermissionsSelectedInPermGroup(thisPermissionsCategoryGroup, value) {
            for (const key in thisPermissionsCategoryGroup.permissions) {
                if (!thisPermissionsCategoryGroup.permissions.hasOwnProperty(key)) {
                    continue
                }

                let thisPermCategoryPermission = thisPermissionsCategoryGroup.permissions[key];
                if (thisPermCategoryPermission.selected != value) {
                    thisPermCategoryPermission.selected = value;
                }
            }
        },
        enableEditMode(editModeObj) {
            this.editingPermissionGroup = true
            let editModeObjCopy = JSON.parse(JSON.stringify(editModeObj))
            let dataDump = {
                name: editModeObjCopy.group_name,
                description: editModeObjCopy.group_description
            }
            editModeObj.dump = dataDump
        },
        cancelEditMode(editModeObj) {
            if (editModeObj.dump) {
                this.editingPermissionGroup = false
                editModeObj.group_name = editModeObj.dump.name
                editModeObj.group_description = editModeObj.dump.description
                delete editModeObj.dump
            }
        },
        saveEditMode(editModeObj) {            
            this.editingPermissionGroup = false
            this.savingChanges = true

            let alertMixin = Swal.mixin({
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
                didOpen: (toast) => {
                    toast.addEventListener('mouseenter', Swal.stopTimer)
                    toast.addEventListener('mouseleave', Swal.resumeTimer)
                }
            });

            let sendData = {
                group_name: editModeObj.group_name,
                group_description: editModeObj.group_description,
                group_id: editModeObj.group_id
            }

            socket.emit('permissions:editPermissionGroup', sendData, (data) => {
                // console.log(data)
                if (data.response == true) {
                    alertMixin.fire({
                        icon: 'success',
                        title: data.message
                    });
                } else {
                    alertMixin.fire({
                        icon: 'error',
                        title: data.error
                    });
                }
                this.savingChanges = false
                this.$emit('getPermissionsGroups')
            })
            delete editModeObj.dump
        },
        enablePermissionsEditMode(editModeObj) {
            this.editingPermissions = true
            let thisPermGroupPermissionsByGroupDump = JSON.parse(JSON.stringify(this.thisPermGroupPermissionsByGroup))
            this.thisPermGroupPermissionsByGroupDump = thisPermGroupPermissionsByGroupDump
        },
        cancelPermissionsEditMode(editModeObj) {
            if (this.thisPermGroupPermissionsByGroupDump) {
                this.editingPermissions = false
                this.thisPermGroupPermissionsByGroup = this.thisPermGroupPermissionsByGroupDump
                delete this.thisPermGroupPermissionsByGroupDump
            }
        },
        savePermissionsEditMode(editModeObj) {
            this.savingPermissions = true
            setTimeout(() => {
                this.savingPermissions = false
                this.editingPermissions = false
                delete this.thisPermGroupPermissionsByGroupDump
            }, 3000);
        }
    }
}
</script>

<style>

</style>